<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group label-for="input-location-name">
      <template v-slot:label>{{ $t("calendarLocationName") }} <span class="text-danger">*</span></template>
      <b-form-input id="input-location-name" type="text" v-model="name" name="name" required minlength="2" maxlength="100" />
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{ $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("save") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import BaseComponent from "@/components/BaseComponent";
  import * as calendarService from "@/service/calendarService";

  @Component
  export default class EditLocationModal extends BaseComponent {

    @Prop({ required: true }) modalId: string;
    @Prop({ required: true }) item: any;

    // Emit decorators only
    @Emit("submitted") __submitted() {}

    name = "";

    formErrorMsg = "";
    isSubmitting = false;

    mounted() {
      // Copy props from original object
      this.name = this.item.name;
    }

    onClickCancel() {
      this.$bvModal.hide(this.modalId);
    }

    async submitForm() {
      this.formErrorMsg = "";

      try {
        this.isSubmitting = true;
        await calendarService.editLocation(this.item.id, this.name.trim());
        this.__submitted();
        this.toastSuccessDelay(this.$t("updateCalendarLocationSuccessful").toString());
        this.$bvModal.hide(this.modalId);

      } catch (e) {
        this.toastError(e);

      } finally {
        this.isSubmitting = false;
      }
    }

  }
</script>
